import { FlexColumn, FlexRowCenter, FormControlLabel, SaveDialog, TextField } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React, { FC } from "react";
import { useCustomViewDialogStore } from "../CustomViewDialogStore";
import { CustomViewItemActionMenuProps } from "./CustomViewItemActionMenu";

const CustomViewItemEditorPopup: FC<CustomViewItemActionMenuProps> = observer(({ customViewItem }) => {
	const {
		cancelEditingPartial,
		description,
		onSavePartial,
		name,
		setDescription,
		setName,
	} = customViewItem;
	const { error } = useCustomViewDialogStore();

	return (
		<SaveDialog
			onClose={cancelEditingPartial}
			onSave={onSavePartial}
			open
			titleRes="CustomViewSaveAs_TT"
		>
			{{ main: (
				<FlexRowCenter justifyContent="center">
					<FlexColumn gap={2}>
						<FormControlLabel
							control={(
								<TextField
									error={!!error}
									helperTextRes={error?.message}
									onChange={setName}
									value={name}
								/>
							)}
							labelPlacement="start"
							required
							res="CustomViewTitle"
						/>
						<FormControlLabel
							control={(
								<TextField onChange={setDescription} value={description} />
							)}
							labelPlacement="start"
							res="Description"
						/>
					</FlexColumn>
				</FlexRowCenter>
			),
			}}
		</SaveDialog>
	);
});

export default CustomViewItemEditorPopup;